import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { MediaBreakPointUp } from '../styles';
import { css, StyleSheet } from 'aphrodite';
import { useNavigate } from 'react-router-dom';
import { useSmMediaQuery } from '@lean-body/src/util/media_query_hooks';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
export const BannerSection = (props) => {
    const { banners, tracker, autoplayDelay, classObject } = props;
    const isSM = useSmMediaQuery();
    const navigate = useNavigate();
    const clickSwiperBanner = (banner) => {
        if (banner.linkUrl) {
            window.open(banner.linkUrl);
        }
        else {
            navigate(banner.makeLinkPath);
        }
        tracker.trackClickEvent({ category: 'Banner Clicks', label: `BannerID: ${banner.id}` });
        tracker.trackHomeBannerClick(banner);
    };
    let loopable = banners.length >= 4;
    const swiperModules = [Autoplay];
    if (isSM) {
        loopable = banners.length >= 3;
    }
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(Swiper, { modules: swiperModules, className: css(styles.swiper), autoplay: { delay: autoplayDelay }, spaceBetween: 12, loop: loopable, pagination: { clickable: true }, slidesPerView: 'auto' }, banners.map((banner, index) => {
            return (React.createElement(SwiperSlide, { key: index, className: css(styles.swiperSlide), onClick: () => clickSwiperBanner(banner) },
                React.createElement("div", { className: css(styles.banner) },
                    React.createElement("img", { className: css(styles.img), src: banner.pcImageSrc }))));
        }))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        overflow: 'hidden',
        width: '100%',
    },
    swiper: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        padding: '10px 20px',
        [MediaBreakPointUp.MD]: {
            padding: '10px 24px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '10px 32px',
        },
    },
    swiperSlide: {
        maxWidth: 409,
    },
    banner: {
        display: 'block',
        position: 'relative',
        cursor: 'pointer',
        overflow: 'hidden',
    },
    img: {
        width: '100%',
        borderRadius: 4,
        display: 'block',
    },
});
